import colors from 'vuetify/lib/util/colors'

export default {
    light: {
        bg_header: colors.green.darken2
    }

}